import React from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { push } from 'react-router-redux';
import { Row, Col } from 'reactstrap';
import * as abonadosActions from 'modules/abonados/action';

@connect(store => ({
  abonadosActivos: store.getIn(['abonados', 'abonadosActivos']),
}))
export default class extends React.Component {
  componentDidMount = () => this.props.dispatch(abonadosActions.getAbonadosActivos());
  add = abonadoId => this.props.dispatch(push('/dashboard/abonados/add/' + abonadoId));
  reservasAutomaticas = id => window.open(`https://jaits.app/api/usuarios/${id}/reservasAutomaticas?access_token=${this.accessToken.getValue()}`, '_blank');
  render() {
    const { abonadosActivos } = this.props;
    return (
      <div>
        <Row className="rowContainer">
          <Col md="12">
            <MaterialUI.Paper zDepth={2} className="container">
              <Row>
                <Col md={{ size: 6, offset: 6 }}>
                  <MaterialUI.TextField
                    fullWidth
                    ref={ref => {
                      this.accessToken = ref;
                    }}
                    hintText="Access token"
                  />
                </Col>
              </Row>
              <MaterialUI.List className="noPadding dividerList">
                {abonadosActivos.map((abonado, i) => (
                  <Row key={i}>
                    <Col md="12">
                      <MaterialUI.ListItem
                        onTouchTap={this.add.bind(this, abonado.getIn(['usuario', 'id']))}
                        primaryText={`${abonado.getIn(['usuario', 'nombre'])} ${abonado.getIn(['usuario', 'apellido'])} Documento: ${abonado.getIn(['usuario', 'documento'])}`}
                        rightIconButton={
                          <MaterialUI.FlatButton
                            icon={<FontAwesome className="iconBar red" name="sticky-note" />}
                            onTouchTap={() => this.reservasAutomaticas(abonado.getIn(['usuario', 'id']))}
                            className="listIcon"
                          />
                        }
                      />
                      <MaterialUI.Divider />
                    </Col>
                  </Row>
                ))}
              </MaterialUI.List>
            </MaterialUI.Paper>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/abonados/components/abonadosActivos.js